// 诚信路由

export default [{
        path: '/integrity/index',
        name: 'tabs',
        component: () =>
            import ('../../pages/integrity/views/home/index.vue'),
        meta: {
            title: '诚信系统'
        }
    }, {
        path: '/integrity/agencyCenter',
        component: () =>
            import ('../../pages/integrity/views/agencyCenter/index.vue'),
        meta: {
            keepAlive: true,
            title: '待办中心'
        }
    },
    { // 任务列表页面
        path: '/integrity/taskList',
        component: () =>
            import ('../../pages/integrity/views/taskList/taskList.vue'),
        meta: {
            keepAlive: true,
            title: '任务列表'
        }
    }, {
        path: '/integrity/SincerityIndexRadar',
        name: 'SincerityIndexRadar',
        component: () =>
            import ('../../pages/integrity/components/SincerityIndexRadar.vue')
    }, {
        path: '/integrity/select',
        component: () =>
            import ('../../pages/integrity/views/select/select.vue'),
        meta: {
            keepAlive: false,
            title: '搜索'
        }
    }, {
        path: '/integrity/missionDetails',
        component: () =>
            import ('../../pages/integrity/views/missionDetails/missionDetails.vue')
    },
    {
        path: '/integrity/workOrder',
        component: () =>
            import ('../../pages/integrity/views/workOrder/index.vue'),
        meta: {
            keepAlive: false,
            title: '工单详情'
        }
    }, {
        path: '/integrity/evaluateDescribe',
        component: () =>
            import ('../../pages/integrity/views/evaluateDescribe/index.vue'),
        meta: {
            title: '评价描述'
        }
    },
    {
        path: '/integrity/moreEnterprises',
        name: 'moreEnterprises',
        component: () =>
            import ('../../pages/integrity/components/moreEnterprises.vue'),
        meta: {
            title: '诚信指数企业排行榜'
        }
    },
    {
        path: '/integrity/districtRanking',
        name: 'districtRanking',
        component: () =>
            import ('../../pages/integrity/components/districtRanking.vue')
    },
    // 新增扣分
    {
        path: '/integrity/addMarks',
        name: 'addMarks',
        component: () =>
            import ('../../pages/integrity/views/addMarks/index.vue'),
        meta: {
            keepAlive: false,
            title: '新增扣分'
        }
    },
    // 扣分详情
    {
        path: '/integrity/pointDetail',
        name: 'pointDetail',
        component: () =>
            import ('../../pages/integrity/views/pointDetail/index.vue'),
        meta: {
            keepAlive: false,
            title: '扣分详情'
        }
    },
    {
        // 待办详情评分任务待编辑

        path: '/integrity/toBeEdited',
                component: ()  =>
            import ('../../pages/integrity/views/toBeEdited/toBeEdited.vue'),
        meta: {
            keepAlive: false,
            title: '待办详情'
        }
    },
    {
        // 待办详情待线下整改

        path: '/integrity/toBeRectified',
                component: ()  =>
            import ('../../pages/integrity/views/toBeEdited/toBeRectified.vue'),
        meta: {
            keepAlive: false,
            title: '待办详情'
        }
    },
    {
        // 待办详情待重新评分

        path: '/integrity/toBeRegraded',
                component: ()  =>
            import ('../../pages/integrity/views/toBeEdited/toBeRegraded.vue'),
        meta: {
            keepAlive: false,
            title: '待办详情'
        }
    },
    {
        // 涉旅企业列表
        path: '/integrity/businessList',
        component: () =>
            import ('../../pages/integrity/views/businessList/businessList.vue'),
        meta: {
            keepAlive: false,
            title: '涉旅企业列表'
        }
    },
    {
        // 评分详情
        path: '/integrity/scoreDetails',
        name: 'scoreDetails',
        component: () =>
            import ('../../pages/integrity/views/scoreDetails/index.vue'),
        meta: {
            keepAlive: false,
            title: '评分详情'
        }
    }, {
        // 下线扣分
        path: '/integrity/referralPoints',
        name: 'referralPoints',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/index.vue'),
        meta: {
            keepAlive: false,
            title: '下线扣分'
        }
    }, {
        // 上传整改资料
        path: '/integrity/uploadFile',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/uploadFile.vue'),
        meta: {
            keepAlive: false,
            title: '上传整改资料'
        }
    }, {
        // 退出重点关注
        path: '/integrity/edit',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/editSupervision.vue'),
        meta: {
            keepAlive: false,
            title: '退出重点关注'
        }
    },
    {
        // 新增整改资料
        path: '/integrity/uploadData',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/uploadData.vue')
    }, {
        // 重点关注详情
        path: '/integrity/supervisionDetails',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/supervisionDetails.vue'),
        meta: {
            keepAlive: false,
            title: '重点关注详情'
        }

    },
    {
        // 黑名单
        path: '/integrity/blackList',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/blackList.vue'),
        meta: {
            keepAlive: false,
            title: '纳入黑名单'
        }
    }, {
        // 法人代表页
        path: '/integrity/legalPerson',
        component: () =>
            import ('../../pages/integrity/views/legalPerson/index.vue'),
        meta: {
            keepAlive: false,
            title: '法人代表'
        }
    }, {
        // 注册信息
        path: '/integrity/registrationInfo',
        component: () =>
            import ('../../pages/integrity/views/registrationInfo/index.vue'),
        meta: {
            keepAlive: false,
            title: '注册信息'
        }

    },
    {
        // 企业详情
        path: '/integrity/companyDetails',
        component: () =>
            import ('../../pages/integrity/views/companyDetails/companyDetails.vue'),
        meta: {
            keepAlive: false,
            title: '企业详情'
        }
    },
    {
        // 审核通过
        path: '/integrity/auditPass',
        component: () =>
            import ('../../pages/integrity/views/missionDetails/auditPass.vue'),
        meta: {
            title: '任务详情'
        }
    },
    {
        // 审核不通过
        path: '/integrity/auditFailed',
        component: () =>
            import ('../../pages/integrity/views/missionDetails/auditFailed.vue'),
        meta: {
            title: '任务详情'
        }
    },
    {
        // 待审核
        path: '/integrity/toAudited',
        component: () =>
            import ('../../pages/integrity/views/missionDetails/toAudited.vue'),
        meta: {
            title: '任务详情'
        }
    },
    { // 企业信息详情（企业详情）
        path: '/integrity/enterpriseDetail',
        component: () =>
            import ('../../pages/integrity/views/enterpriseDetail/index.vue'),
        meta: {
            title: '企业详情'
        }
    },
    // { // 播放器
    //     path: '/integrity/playerTv',
    //     component: () =>
    //         import('../../pages/integrity/views/home/playerTv.vue'),
    //         meta: {
    //             title: '企业详情'
    //            }
    // }

    { // 企业详情(扫一扫)
        path: '/integrity/scanEnterpriseDetail',
        component: () =>
            import ('../../pages/integrity/views/enterpriseDetail/scanEnterpriseDetail.vue'),
        meta: {
            title: '企业详情'
        }
    },
    { // 空白页面暂无数据(扫一扫)
        path: '/integrity/scanEmpty',
        component: () =>
            import ('../../pages/integrity/views/enterpriseDetail/scanEmpty.vue'),
        meta: {
            title: '扫一扫'
        }
    },
    { // 空白页面找不到该企业(扫一扫)
        path: '/integrity/scanEnterEmpty',
        component: () =>
            import ('../../pages/integrity/views/enterpriseDetail/scanEnterEmpty.vue'),
        meta: {
            title: '扫一扫'
        }
    },
    { // V1.4 首页-退出重点关注待审核
        path: '/integrity/exitSupervision',
        component: () =>
            import ('../../pages/integrity/views/important/exitSupervision.vue'),
        meta: {
            title: '待办详情'
        }
    },
    { // V1.4 退出重点关注审核不通过
        path: '/integrity/examine',
        component: () =>
            import ('../../pages/integrity/views/important/examine.vue'),
        meta: {
            title: '待办详情'
        }
    },
    { // V1.4 重点关注企业待评分
        path: '/integrity/scored',
        component: () =>
            import ('../../pages/integrity/views/important/scored.vue'),
        meta: {
            title: '待办详情'
        }
    },
    { // V1.4 黑名单预警企业待评分
        path: '/integrity/earlyWarning',
        component: () =>
            import ('../../pages/integrity/views/important/earlyWarning.vue'),
        meta: {
            title: '待办详情'
        }
    },
    { // V1.4 发布任务
        path: '/integrity/sendTask',
        component: () =>
            import ('../../pages/integrity/views/important/sendTask.vue'),
        meta: {
            title: '发布任务'
        }
    },
    { // V1.4 申请单
        path: '/integrity/application',
        component: () =>
            import ('../../pages/integrity/views/apply/application.vue'),
        meta: {
            title: '申请单'
        }
    },
    { // V1.4 申请详情
        path: '/integrity/applicationDetele',
        component: () =>
            import ('../../pages/integrity/views/apply/applicationDetele.vue'),
        meta: {
            title: '申请单详情'
        }
    },
    { // V1.4 退出重点关注
        path: '/integrity/editRegulation',
        component: () =>
            import ('../../pages/integrity/views/referralPoints/editRegulation.vue'),
        meta: {
            title: '退出重点关注'
        }
    },
    {
        path: '/integrity/evaluationStatistical',
        component: () =>
            import ('../../pages/integrity/views/home/evaluationStatistical.vue'),
        meta: {
            title: '评价计划执行统计'
        }
    }
]